import { Portion } from './portion.model';
import { Energy } from './energy.model';
import {Weight} from "./weight.model";
import { helpers } from "../helpers";

export class Product {

  constructor(id, externalId, name, weight, energy, category, allergen, disliked, nutrients, portion) {
    this._id = id;
    this._externalId = externalId;
    this._name = name;
    this._weight = weight;
    this._energy = energy;
    this._category = category;
    this._allergen = allergen;
    this._disliked = disliked;
    this._nutrients = nutrients;
    this.portion = portion;
  }

  get id() {
    return this._id;
  }

  get externalId() {
    return this._externalId;
  }

  get name() {
    return this._name;
  }

  get weight() {
    return this._weight;
  }

  get energy() {
    return new Energy(this._energy.amount);
  }

  get energyInPortion() {
    return new Energy(this._energy.amount * this.portion.getFactor());
  }

  get category() {
    return this._category;
  }

  get allergen() {
    return this._allergen;
  }

  get disliked() {
    return this._disliked;
  }

  get nutrients() {
    return this._nutrients;
  }

  sumNutrientById(id) {
    const nutrient = this.findNutrient(id);

    if (typeof nutrient === 'undefined') {
      return 0;
    }

    return nutrient * this.portion.getFactor();
  }

  findNutrient(id) {
    return this._nutrients[id];
  }

  getGlicemicIndex() {
    const gi = this.findNutrient(156);

    if (typeof gi === 'undefined') {
      return 0;
    }

    return gi;
  }

  calculateGlicemicLoad() {
    const totalCarbohydrates = this.getCarbohydrates();
    const totalFiber = this.getFiber();
    const glicemicIndex = this.getGlicemicIndex();

    return ((totalCarbohydrates - totalFiber) * glicemicIndex) / 100;
  }

  getCarbohydrates() {
    const carbo = this.findNutrient(3);

    if (typeof carbo === 'undefined') {
      return 0;
    }

    return carbo * this.portion.getFactor();
  }

  getFiber() {
    const fiber = this.findNutrient(20);

    if (typeof fiber === 'undefined') {
      return 0;
    }

    return fiber * this.portion.getFactor();
  }

  getNutrientsInPortion() {
    const factor = this.portion.getFactor();
    let nutrients = helpers.deepClone(this._nutrients);
    for (const externalId in nutrients) {
      nutrients[externalId] *= factor;
    }
    return nutrients;
  }

  get portion() {
    return this._portion;
  }

  set portion(portion) {
    if (!(portion instanceof Portion)) {
      throw new Error('portion has to be instance of Portion Class');
    }

    this._portion = portion;
  }

  getTotalWeight() {
    const amount = this._portion.amount * this._portion.weight.amount;
    return new Weight(amount, 'gram');
  }

  toJSON() {
    return {
      id: this.id,
      externalId: this.externalId,
      name: this.name,
      weight: this.weight,
      energy: this.energy,
      category: this.category,
      allergen: this.allergen,
      disliked: this.disliked,
      nutrients: this.nutrients,
      portion: this.portion,
    };
  }
}
